export const byteLength = require("utf8-length") as (
  string: string | Buffer
) => number;



// WEBPACK FOOTER //
// ./src/util/bytelength.web.ts